import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
  Spinner,
  Center
} from '@chakra-ui/react';
import axios from "axios";
const ReturnRequest = () => {
  const toast= useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [newRequests, setNewRequests] = useState([]);
  const [reviewedRequests, setReviewedRequests] = useState([]);
  const [loading, setLoading] = useState(true);



  const [displayedNewRequests, setDisplayedNewRequests] = useState(10);
  const [displayedReviewedRequests, setDisplayedReviewedRequests] = useState(10);

  const fetchReturnRequests = async () => {
    try {
      const response = await axios.get("https://leatherandstyle.netlify.app/.netlify/functions/getReturnRequests");
      if (response.status === 200) {
        setLoading(false);
        const data = response.data;
        // console.log("data:", data);
  
        const newOnes = [];
        const reviewedOnes = [];
  
        for (let obj of data) {
          if (obj.isReviewed === 0) {
            newOnes.push(obj);
          } else {
            reviewedOnes.push(obj);
          }
        }
  
        setNewRequests(newOnes);
        setReviewedRequests(reviewedOnes);
      }
    } catch (e) {
      console.log("err in fetching return requests", e);
      setLoading(false)
      toast({
        title: "Error",
        description: "Failed to fetch return requests",
        status: "error",
        isClosable: true,
        duration: 3000,
        position: "top-right",
      });
    }
  };
  

  
  useEffect(()=>{
    fetchReturnRequests();
  }, []);

  // Handle Request Click
  const handleRequestClick = (request, type) => {
    setSelectedRequest({ ...request, type });
    onOpen();
  };

  // Handle Status Change
  const handleChangeStatus = async () => {
    if (!selectedRequest) return;
  
    try {
      const updatedStatus = selectedRequest.isReviewed === 0 ? 1 : 0;
  
      const body = {
        id: selectedRequest._id,
        status: updatedStatus,
      };
  
      const response = await axios.post("https://leatherandstyle.netlify.app/.netlify/functions/updateReturnRequest", body);
  
      if (response.status === 200) {
        // ✅ Re-fetch requests and close modal
        setLoading(true);
        await fetchReturnRequests();
        onClose();
      }
    } catch (e) {
      console.error("Error updating status:", e);
      toast({
        title: "Update Failed",
        description: "Could not update return request status.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };
  

  // Show More/Less Logic
  const handleShowMoreNew = () => {
    setDisplayedNewRequests(prev => prev + 10);
  };

  const handleShowLessNew = () => {
    setDisplayedNewRequests(10);
  };

  const handleShowMoreReviewed = () => {
    setDisplayedReviewedRequests(prev => prev + 10);
  };

  const handleShowLessReviewed = () => {
    setDisplayedReviewedRequests(10);
  };

  return (
    <Box className="CGR-main-container" p={5}>
      {loading ? (
         <Center height="100vh" background="rgba(255, 255, 255, 0.9)">
                  <Box textAlign="center">
                    <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
                    <Box mt={4} fontSize="lg" color="gray.600">
                      Please wait loading ...
                    </Box>
                  </Box>
                </Center>
      ):(
        <>
        <div className="CGR-main-header">Return Requests</div>
        <div className="CGR-main-subheader">total requests: {newRequests.length + reviewedRequests.length}</div>
        <Tabs isFitted variant="enclosed" className="CGR-tabs" mt={4}>
          <TabList>
            <Tab>New Requests</Tab>
            <Tab>Reviewed Requests</Tab>
          </TabList>
  
          <TabPanels>
            {/* New Requests */}
            <TabPanel>
              {newRequests.slice(0, displayedNewRequests).map(req => (
                <Box
                  key={req._id}
                  className="request-bar"
                  onClick={() => handleRequestClick(req, 'new')}
                  border="1px solid #ccc"
                  p={3}
                  borderRadius="md"
                  mb={2}
                  cursor="pointer"
                  _hover={{ bg: 'gray.100' }}
                >
                  <Text fontWeight="bold">{req.orderData?.shipping?.firstName} {req.orderData?.shipping?.lastName}</Text>
                  <Text fontSize="sm" color="gray.600">
                    {req.reason}
                  </Text>
                </Box>
              ))}
              {newRequests.length > 10 && (
                <div className="show-buttons">
                  {displayedNewRequests < newRequests.length ? (
                    <Button onClick={handleShowMoreNew} colorScheme="blue" size="sm" mt={2}>
                      Show More
                    </Button>
                  ) : (
                    <Button onClick={handleShowLessNew} colorScheme="red" size="sm" mt={2}>
                      Show Less
                    </Button>
                  )}
                </div>
              )}
            </TabPanel>
  
            {/* Reviewed Requests */}
            <TabPanel>
              {reviewedRequests.slice(0, displayedReviewedRequests).map(req => (
                <Box
                  key={req._id}
                  className="request-bar"
                  onClick={() => handleRequestClick(req, 'reviewed')}
                  border="1px solid #ccc"
                  p={3}
                  borderRadius="md"
                  mb={2}
                  cursor="pointer"
                  _hover={{ bg: 'gray.100' }}
                >
                  <Text fontWeight="bold">{req.orderData?.shipping?.firstName} {req.orderData?.shipping?.lastName}</Text>
                  <Text fontSize="sm" color="gray.600">
                    {req.reason}
                  </Text>
                </Box>
              ))}
              {reviewedRequests.length > 10 && (
                <div className="show-buttons">
                  {displayedReviewedRequests < reviewedRequests.length ? (
                    <Button onClick={handleShowMoreReviewed} colorScheme="blue" size="sm" mt={2}>
                      Show More
                    </Button>
                  ) : (
                    <Button onClick={handleShowLessReviewed} colorScheme="red" size="sm" mt={2}>
                      Show Less
                    </Button>
                  )}
                </div>
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
  
        {/* Modal for Request Details */}
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{selectedRequest?.orderData?.shipping?.firstName} {selectedRequest?.orderData?.shipping?.lastName}</ModalHeader>
            <ModalBody>
            <Text><b>Order Id:</b> {selectedRequest?.orderData.orderId}</Text>
            <Text><b>Date:</b> {selectedRequest?.orderData.updatedAt}</Text>
              <Text><b>Phone:</b> {selectedRequest?.orderData?.shipping?.phone}</Text>
              <Text><b>Amount Paid:</b> ₹ {selectedRequest?.orderData.payment.amount} /-</Text>
              <Text><b>Reason for Return:</b> {selectedRequest?.reason}</Text>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={onClose}>
                Close
              </Button>
              <Button
                onClick={handleChangeStatus}
                colorScheme={selectedRequest?.isReviewed === 0 ? 'green' : 'orange'}
              >
                {selectedRequest?.isReviewed === 0  ? 'Mark as Reviewed' : 'Mark as Unread'}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal></>
      )}
     
    </Box>
  );
};


export default ReturnRequest;
